<template>
    <b-container fluid class="animated fadeIn">
        <h1>Ajuizamento - Exibir Erros</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <CompOpcoesPesquisa
                        :filtro="filtro"
                        :dados="dados"
                        @filtrar="filtrar"
                        @limparFiltro="limparFiltro"
                         />
                    <b-row class="d-flex justify-content-between mt-2">
                        <b-col align-self="end">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <b-button class="mx-1 " variant="primary"  @click.prevent="encaminharParaDisponiveis" :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Encaminhar para Disponíveis</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas com Erros - Valor Total: <strong>R$ {{ configTable.totalGeral | currency }}</strong> &nbsp; Quantidade: <strong>{{ configTable.quantidadeGeral }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaErrosAjuizamento
                                        :resultado="resultado"
                                        :fields="fields"
                                        :configTable="configTable"
                                        :selecteds="selecteds"
                                        @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas"/>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col align-self="end">
                                            <label style="float:right">Quantidade selecionada: {{ selecteds.length }} &nbsp; Valor Total: <strong>R$ {{ totalSelectedValue | currency }}</strong></label>
                                        </b-col>
                                    </b-row>

                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <CompBotoesFooter 
                        @exportCSV="exportCSV" 
                        @voltar="voltar" />
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompOpcoesPesquisa from '../shared/components/CompOpcoesPesquisaErroAjuizamentoProtesto'
import CompBotoesFooter from './components/CompBotoesFooter'
import CompPaginacao from './components/CompPaginacao'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompTabelaErrosAjuizamento from './components/CompTabelaErrosAjuizamento'

export default {
    name: 'ExibirErrosAjuizamento',
    components: {
        CompOpcoesPesquisa,
        CompBotoesFooter,
        CompPaginacao,
        CompExibirOcultarColuna,
        CompTabelaErrosAjuizamento,
    },
    data() {
        return {
            ano: null,
            mes: null,
            filtro: {
                filtrosCombo: [],
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                tipoCredito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                erro: null,
            },
            dados: {
                comarcas: [],
                origens: [],
                creditos: [],
                filtrosCombo: [{codFiltro: 1, text: 'Nº da Dívida'}, {codFiltro: 2, text: 'CPF/CNPJ'}, {codFiltro: 3, text: 'Contribuinte'},
                {codFiltro: 4, text: 'CADICMS'},{codFiltro: 5, text: 'Comarca'},{codFiltro: 6, text: 'Tipo de Crédito'},{codFiltro: 7, text: 'Data de Inscrição'},{codFiltro: 8, text: 'Erro'}]
            },
            configTable: {
                perPage: 100,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            loadCSV: false,
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
        totalSelectedValue() {
            let total = 0.00
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            })
            return total
        },
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
    },
    methods: {
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                tipoCredito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                erro: null,
            }
        },
        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.consultarDividas()
        },

        /**
         * Encaminha CDA's para disponiveis
         */
        encaminharParaDisponiveis() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaErroAjuizamento/encaminharDisponiveis`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Dívidas foram encaminhadas para disponíveis com sucesso!'] });
                this.selecteds = []
            })
            .catch((error) => {
                if(error.response.status === 400){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro ocorreu no desfazimento EPA-DAE, o histórico das dívidas selecionadas foi atualizado com o erro.'] });
                }
                if(error.response.status === 500){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro de comunicação ocorreu com um sistema externo, tente novamente mais tarde.'] });
                }
                this.selecteds = []
            })   
            .finally(() => {
                this.configTable.checkedAll = false
                this.loadingExit()
                this.consultarDividas()
            })
        },

         /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },
        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        checkClassTable(i) {
            if(i == 1 || i == 2 || i == 5 || i == 6)
                return 'text-center'
            if(i == 7)
                return 'text-right'
            return ''
        },

        /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true
            if(this.selecteds.length) {
                this.loadingEnter()
               axios.post(`${urlApi}/v1/cdaErroAjuizamento/exportarCsv`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                    this.loadingExit()
                })
            } else {
                const filtro = {
                    numeroDivida: this.filtro.numeroDivida,
                    cpfCnpj: this.filtro.cpfCnpj,
                    cadimcs: this.filtro.cadimcs,
                    comarca: this.filtro.comarca,
                    contribuinte: this.filtro.contribuinte,
                    credito: this.filtro.credito,
                    dtInscricaoInicio: this.filtro.dtInscricaoInicio ? this.filtro.dtInscricaoInicio.toString() : null,
                    dtInscricaoFim: this.filtro.dtInscricaoFim ? this.filtro.dtInscricaoFim.toString() : null,
                    erro: this.filtro.erro,
                }
                this.loadingEnter()
                axios.post(`${urlApi}/v1/cdaErroAjuizamento/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                    this.loadingExit()
                })
            }
        },

        /**
         * Efetua o download do CSV a partir do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CDAErroAjuizamento.csv');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        escapePerPage() {
            if (this.configTable.perPage == 'Todos') {
                return '';
            }
            return '&perPage='  + this.configTable.perPage
        },

         /**
         * Consultar divídas
         */
        async consultarDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                contribuinte: this.filtro.contribuinte,
                cadimcs: this.filtro.cadimcs,
                comarca: this.filtro.comarca,
                credito: this.filtro.credito,
                dtInscricaoInicio: this.filtro.dtInscricaoInicio,
                dtInscricaoFim: this.filtro.dtInscricaoFim,
                erro: this.filtro.erro
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaErroAjuizamento/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}` + this.escapePerPage()  + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                this.configTable.rows = response.data.rows
                this.configTable.totalGeral = response.data.valorTotal
                this.configTable.quantidadeGeral = response.data.totalDividas

                this.resultado.forEach(result => {
                    result.dividas.forEach(divida => {
                        this.selecteds.forEach(selected => {
                            if(divida.id == selected.id) {
                                divida.checked = true
                                result.checked = true
                            }
                        })
                    })
                })
                
            }).finally(() => {
                this.loadingExit()
            })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.comarcas = response.data
            })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaErroAjuizamento/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.creditos = response.data
            })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'cdaErroAjuizamento'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        }

    },

    mounted() {
        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        this.$store.commit("setMessages", {});

        this.consultarDividas()
        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoCredito()
    },

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.fonte-branca {
    color: #FFF;
}

.fonte-branca:hover {
    color: #FFF;
}

.fonte-branca:active {
    color: #FFF !important;
}

.table-sub-item, .table-sub-item > th, .table-sub-item > td {
    background-color: rgb(237, 237, 238);
}
</style>
